(function ($) {

    // Auto-rotating carousel for .c-slider elements
    // Pauses on hover/focus, toggles with a pause/play button

    var INTERVAL = 5000; // 5 seconds between slides
    var DATA_KEY = 'sliderAutoRotate';
    var PLAYING_CLASS = 'is-playing';
    var PAUSED_CLASS = 'is-paused';

    function SliderAutoRotate($slider) {
        this.$slider = $slider;
        this.$flags = $slider.find('.c-slider__flag');
        this.$playPauseBtn = $slider.find('.c-slider__playpause');
        this.$arrows = $slider.find('.c-slider__show');
        this.$playIcon = this.$playPauseBtn.find('.c-slider__playpause--play');
        this.$pauseIcon = this.$playPauseBtn.find('.c-slider__playpause--pause');
        this.timer = null;
        this.isPlaying = true;

        this.init();
    }

    SliderAutoRotate.prototype.init = function () {
        if (this.$flags.length < 2) return; // No rotation needed for single slide

        var self = this;

        // Start auto-rotation
        this.$slider.addClass(PLAYING_CLASS);
        this.start();

        // Pause on hover
        this.$slider.on('mouseenter.slider-autorotate focusin.slider-autorotate', function () {
            self.pause(true);
        });

        // Resume on mouse leave
        this.$slider.on('mouseleave.slider-autorotate focusout.slider-autorotate', function () {
            self.resume();
        });

        // Pause/play button click
        this.$playPauseBtn.on('click.slider-autorotate', function () {
            if (self.isPlaying) {
                self.pause(false);
            } else {
                self.play();
            }
        });

        // Pause on prev/next arrow click (user-initiated navigation)
        this.$arrows.on('click.slider-autorotate', function () {
            self.pause(false);
        });
    };

    SliderAutoRotate.prototype.getActiveIndex = function () {
        var index = 0;
        this.$flags.each(function (i) {
            if ($(this).is(':checked')) {
                index = i;
                return false;
            }
        });
        return index;
    };

    SliderAutoRotate.prototype.advance = function () {
        var current = this.getActiveIndex();
        var next = (current + 1) % this.$flags.length;
        this.$flags.eq(next).prop('checked', true);
    };

    SliderAutoRotate.prototype.start = function () {
        var self = this;
        this.stop();
        this.timer = setInterval(function () {
            self.advance();
        }, INTERVAL);
    };

    SliderAutoRotate.prototype.stop = function () {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    };

    SliderAutoRotate.prototype.pause = function (isHover) {
        if (this.isPlaying) {
            this.stop();
            this.isPlaying = false;
            this.$slider.removeClass(PLAYING_CLASS).addClass(PAUSED_CLASS);
        }
    };

    SliderAutoRotate.prototype.resume = function () {
        // Only auto-resume if paused by hover (not by explicit button click)
        // We use a data attribute to track whether pause was from hover or click
        if (this.$slider.data('slider-paused-by-user')) return;
        this.play();
    };

    SliderAutoRotate.prototype.play = function () {
        if (!this.isPlaying) {
            this.start();
            this.isPlaying = true;
            this.$slider.removeData('slider-paused-by-user');
            this.$slider.removeClass(PAUSED_CLASS).addClass(PLAYING_CLASS);
        }
    };

    // Override pause to track user-click vs hover
    var origPause = SliderAutoRotate.prototype.pause;
    SliderAutoRotate.prototype.pause = function (isHover) {
        origPause.call(this, isHover);
        if (!isHover) {
            this.$slider.data('slider-paused-by-user', true);
        }
    };

    // Initialize on DOM ready
    $(function () {
        $('.c-slider').each(function () {
            var $slider = $(this);
            if (!$slider.data(DATA_KEY)) {
                $slider.data(DATA_KEY, new SliderAutoRotate($slider));
            }
        });
    });

}(jQuery));
